var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-row",
    _vm._l(_vm.products, function (product) {
      return _c(
        "el-col",
        { key: product.id, attrs: { xs: 24, sm: 8, md: 8, lg: 8 } },
        [
          _c("el-card", [
            _c("img", {
              attrs: { src: "/api/public/photos/" + product.photos[0].id },
            }),
            _vm._v(" "),
            _c("div", [
              _c("div", [_vm._v(_vm._s(product.name))]),
              _vm._v(" "),
              _c("div", [_vm._v(_vm._s(product.price) + " рубля")]),
              _vm._v(" "),
              _c("div", [_vm._v(_vm._s(product.composition))]),
            ]),
            _vm._v(" "),
            _c(
              "div",
              [
                _c(
                  "router-link",
                  {
                    attrs: {
                      to: {
                        name: "product",
                        params: {
                          categoryId: product.category.id,
                          productId: product.id,
                        },
                      },
                    },
                  },
                  [_vm._v("Подробнее")]
                ),
              ],
              1
            ),
          ]),
        ],
        1
      )
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }